import type { Dispatch, SetStateAction } from 'react';

// https://grrr.tech/posts/2021/typescript-partial
// Partial type which also applies partial thinking to its nested objects.
export type NestedPartial<K> = {
  [attr in keyof K]?: K[attr] extends object
    ? NestedPartial<K[attr]>
    : K[attr] extends object | null
      ? NestedPartial<K[attr]> | null
      : K[attr] extends object | null | undefined
        ? NestedPartial<K[attr]> | null | undefined
        : K[attr];
};

export type Maybe<T> = T | null;

export type StateUpdater<T> = Dispatch<SetStateAction<T>>;

export const isPrimitive = (value: unknown): value is string | number | boolean => {
  return ['string', 'number', 'boolean'].includes(typeof value);
};

export type objectType = {
  [key: string]: string;
};

export const ArrayToObject = (categories: objectType | string[]): objectType => {
  if (!categories) return {};

  if (Array.isArray(categories)) {
    return categories.reduce((acc, category, index) => {
      if (typeof category === 'string') {
        acc[String(index)] = category;
      }
      return acc;
    }, {} as objectType);
  }

  return categories;
};
